import { render, staticRenderFns } from "./tab-details.vue?vue&type=template&id=55efdca4"
import script from "./tab-details.vue?vue&type=script&lang=js"
export * from "./tab-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports